/**
 * TikTok Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import type { IconProps } from '../../types';

export function TikTokIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'TikTok',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faTiktok}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
